import React, { Component } from "react";
import profileImage from "../assets/img/profile-img.jpg";

class AboutSection extends Component {
  render() {
    return (
      <section id="about" className="about">
        <div className="container">
          <div className="section-title">
            <h2>About</h2>
            <p style={{ textAlign: 'justify' }}>
              Associate Software Engineer in the information technology and services
              industry. Skilled in C++, C#, jQuery, Javascript, Core Java,
              .NET Core, Angular, and ionic Framework. Strong engineering
              professional with a Bachelor of Technology - B.Tech focused
              in Computer Science from Rajasthan Technical University, Kota. </p>
          </div>

          <div className="row">
            <div className="col-lg-4" data-aos="fade-right">
              <img
                src={profileImage}
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
              <h3>Software Developer</h3>
              <p className="fst-italic" style={{ textAlign: 'justify' }}>
                Having a Bachelor Of Technology in Computer Science Engineering and 1.5+ years of experience in C#, ADO .Net, SQL Server, ASP.Net, MVC, ASP.Net Core, JQuery, Angular, ionic, and JavaScript.
                Currently associated with Sevina Technologies - Ahmedabad as an Associate software engineer.
              </p>
              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>Birthday:</strong> <span>05 Jan 1998</span>
                    </li>

                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>Phone:</strong> <span>+91 90015-35885</span>
                    </li>
                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>City:</strong> <span>Ajmer(Raj.), Bharat </span>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>Degree:</strong> <span>B.Tech(Computer Science)</span>
                    </li>
                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>Email:</strong>{" "}
                      <span>naharakshay8@gmail.com</span>
                    </li>
                    <li>
                      <i className="bi bi-chevron-right"></i>{" "}
                      <strong>Freelance:</strong> <span>Available</span>
                    </li>
                  </ul>
                </div>
              </div>
              <p>
                In Sevina Technology I'm responsible for programming our proprietary
                 software products to implement new features and support current applications.
                Additional responsibilities include being part of a collaborative team that 
                produces a quality product for our clients. Perform problem analysis,
                solution determination, code design and development, 
                integration, test, modification, documentation, and provide software support
                 to clients.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutSection;
